<script>
    // Header of the admin apps: back link, title, tabs and the market switch. One look and one behaviour for the SEO app and the
    // VisualCMS app (and the next admin app).  decision: [1]
    //
    //   tabs     [{ id, title }]               market   current value, a language id as string or 'all'
    //   markets  [{ value, text }]  (empty = no switch)   onTab(id) / onMarket(value) are called on a click
    let {
        title = '',
        backHref = '',
        backLabel = 'Admin',
        tabs = [],
        tab = '',
        onTab = () => {},
        markets = [],
        market = '',
        onMarket = () => {},
        marketLabel = 'Markt',
        children = undefined,
    } = $props()
</script>

<header class="border-b border-[#d0d6dd] bg-white">
    <div class="mx-auto flex w-full max-w-[1600px] flex-wrap items-center gap-4 px-4 py-2">
        {#if backHref}
            <a href={backHref} class="text-[13px] text-[#14467a] no-underline hover:underline">&larr; {backLabel}</a>
        {/if}
        <strong class="text-[15px]">{title}</strong>

        {#if tabs.length}
            <nav class="flex flex-wrap gap-1">
                {#each tabs as t (t.id)}
                    <button type="button" onclick={() => onTab(t.id)} data-tab={t.id} aria-current={tab === t.id ? 'page' : undefined}
                            class="cursor-pointer rounded border px-3 py-1 text-[13px] {tab === t.id
                                ? 'border-[#14467a] bg-[#eaf3fb] font-semibold text-[#14467a]'
                                : 'border-[#d0d6dd] bg-white text-[#41506a]'}">
                        {t.title}
                    </button>
                {/each}
            </nav>
        {/if}

        <div class="ml-auto flex items-center gap-3 text-[13px]">
            {#if children}{@render children()}{/if}
            {#if markets.length}
                <div class="flex items-center gap-2" role="group" aria-label={marketLabel}>
                    <span class="text-[#5b6b7c]">{marketLabel}</span>
                    <div class="flex overflow-hidden rounded border border-[#14467a]">
                        {#each markets as m (m.value)}
                            <button type="button" data-market={m.value} onclick={() => onMarket(m.value)} aria-pressed={String(market) === String(m.value)}
                                    class="cursor-pointer border-0 px-3 py-1 text-[13px] {String(market) === String(m.value)
                                        ? 'bg-[#14467a] text-white' : 'bg-white text-[#14467a]'}">{m.text}</button>
                        {/each}
                    </div>
                </div>
            {/if}
        </div>
    </div>
</header>
